import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthApi from "../../App/api/auth.apis";
import { toast } from "react-toastify";
import { isValidToken } from "../../utils/jwtConfig";
// import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
// import { app } from "../../firebase";

export const storeRegister = createAsyncThunk(
  "register",
  async (payload, { rejectWithValue }) => {
    // console.log("slice register payload", payload);
    try {
      const response = await AuthApi.register(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || "Registration failed"
      );
    }
  }
);

export const AdminLogin = createAsyncThunk(
  "login",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await AuthApi.login({emailOrPhone: payload.emailOrPhone,password: payload.password},payload?.roleId);
      // console.log('response.data',response.data);
      
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response.data.message || "Registration failed"
      );
    }
  }
);

export const adminLogout = createAsyncThunk("logout", async (payload) => {
  try {
    const response = await AuthApi.logoutUser(payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || "Logout failed");
  }
});

export const initialize = createAsyncThunk(
  "initialize",
  async (_, { rejectWithValue }) => {
    try {
      const accessToken = localStorage.getItem("accessToken") || "";

      if (accessToken && isValidToken(accessToken)) {
        const response = await AuthApi.currentUser();
        const { user } = response.data;

        return {
          isAuthenticated: true,
          user,
        };
      } else {
        return {
          isAuthenticated: false,
          user: null,
        };
      }
    } catch (error) {
      console.error(error);
      return rejectWithValue("Initialization failed");
    }
  }
);

// export const loginWithGoogle = createAsyncThunk(
//   "loginWithGoogle",
//   async (payload, { rejectWithValue }) => {
//     const auth = getAuth(app);
//     const provider = new GoogleAuthProvider();
//     try {
//       const res = await signInWithPopup(auth, provider);
//       console.log(res.user);
//       return res.user;
//     } catch (err) {
//       return rejectWithValue(err.response.data.message || "Login failed");
//     }
//   }
// );

const storeSlice = createSlice({
  name: "store",
  initialState: {
    token: false,
    currentUser: null,
    loading: false,
    error: false,
    success: false,
    isInitialized: false,
    isAuthenticated: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Initialize builder
      .addCase(initialize.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(initialize.fulfilled, (state, action) => {
        state.loading = false;
        state.isInitialized = true;
        state.isAuthenticated = action.payload.isAuthenticated;
        state.currentUser = action.payload.user;
      })
      .addCase(initialize.rejected, (state, action) => {
        state.loading = false;
        state.isInitialized = true;
        state.isAuthenticated = false;
        state.currentUser = null;
        toast.error(action.payload || "Initialization failed");
      })
      // store register builder
      .addCase(storeRegister.pending, (state) => {
        state.loading = true;
        state.error = false;
        state.success = false;
      })
      .addCase(storeRegister.fulfilled, (state, action) => {
        state.loading = false;
        state.error = false;
        state.success = true;
        state.currentUser = action.payload;
        toast.success("User Registered Successfully");
      })
      .addCase(storeRegister.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.success = false;
      })

      // store login builder
      .addCase(AdminLogin.pending, (state) => {
        state.loading = true;
        state.error = false;
        state.success = false;
      })
      .addCase(AdminLogin.fulfilled, (state, action) => {
        // console.log("Login fulfilled action payload:", action.payload);
        state.loading = false;
        state.error = false;
        state.success = true;

        state.token = true;
        state.currentUser = action.payload;
        localStorage.setItem("accessToken", action.payload.data.accessToken);
        localStorage.setItem(
          "refreshToken",
          action.payload.data.refreshToken
        );
        toast.success(
          `Welcome Back, ${action.payload.data?.user?.first_name}`
        );
        // if (action.payload.data.user.user_role.role_id===1 && action.payload.data.user.user_role.name==="admin" && action.payload.data && action.payload.data.accessToken) {
        // } else {
        //   console.error("Invalid payload structure:", action.payload);
        //   if (action.payload.statusCode===200 && action.payload.data.user.user_role.role_id!==1 && action.payload.data.user.user_role.name!=="admin") {
        //     toast.error("Unautherized user");
        //   } else {
        //     toast.error("Unexpected response format from server.");
            
        //   }
        // }
      })
      .addCase(AdminLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.success = false;
      })

      // // store login with google builder
      // .addCase(loginWithGoogle.pending, (state) => {
      //   state.loading = true;
      //   state.error = false;
      //   state.success = false;
      // })
      // .addCase(loginWithGoogle.fulfilled, (state, action) => {
      //   console.log("Login fulfilled action payload:", action.payload);
      //   state.loading = false;
      //   state.error = false;
      //   state.success = true;

      //   if (action.payload && action.payload.accessToken) {
      //     state.token = true;
      //     state.currentUser = action.payload;
      //     localStorage.setItem("accessToken", action.payload.accessToken);
      //     localStorage.setItem("refreshToken", action.payload.refreshToken);
      //     toast.success(`Welcome Back, ${action.payload?.displayName}`);
      //   } else {
      //     console.error("Invalid payload structure:", action.payload);
      //     toast.error("Unexpected response format from server.");
      //   }
      // })
      // .addCase(loginWithGoogle.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = true;
      //   state.success = false;
      // })

      // store logout builder
      .addCase(adminLogout.pending, (state) => {
        state.loading = true;
        state.error = false;
        state.success = false;
      })
      .addCase(adminLogout.fulfilled, (state, action) => {
        state.loading = false;
        state.error = false;
        state.success = true;
        state.currentUser = null;
        state.token = false;
        window.location.href = "/";
        localStorage.clear();
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
      })
      .addCase(adminLogout.rejected, (state) => {
        state.loading = false;
        state.error = true;
        state.success = false;
        state.currentUser = null;
        state.token = false;
        window.location.href = "/";
        localStorage.clear();
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
      });
  },
});

export default storeSlice.reducer;
